import { type RouteObject } from "react-router-dom";

import {
  ACCESS_LEVELS,
  AUTH_ROLES,
  PERMISSION_AREAS,
} from "api/common/types/auth.types";
import NistDetails from "components/NIST/NISTDetails";
import AssuranceMaintenanceDetails from "components/Products/ProductManager/AssuranceMaintenanceDetails/";
import ProductDetails from "components/Products/ProductManager/ProductDetails";
import ProductEventLog from "components/Products/ProductManager/ProductEventLog";
import SaveSignature from "components/Products/ProductManager/SaveSignature";
import ProductsOverview from "features/memberPortal/products/PINE/ProductsOverview.screen";
import ProductUpdateModal from "features/memberPortal/products/productDetails/ProductUpdates/modals/ProductUpdate.modal";
import ProductUpdates from "features/memberPortal/products/productDetails/ProductUpdates/ProductUpdates.screen";
import ProficiencyFeedbackModal from "features/memberPortal/products/productDetails/ProficiencyFeedback/components/proficiencyFeedbackForm/modal/ProficiencyFeedback.modal";
import ProductManager from "features/memberPortal/products/ProductManager.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { VENDOR, NIAP, VALIDATOR } = AUTH_ROLES;

const productRoutes: RouteObject[] = [
  {
    path: "products",
    children: [
      // This needs to be accessible by vendors, so even though it is under "products/" we need to put it outside of the AuthenticatedRoute
      {
        path: "save_signature/:signer/:packageType/:signature_id",
        element: <SaveSignature />,
      },
      {
        element: (
          <AuthenticatedRoute
            requiredPermissions={{
              area: PERMISSION_AREAS.PROJECT,
              access: ACCESS_LEVELS.READ,
            }}
            restrictedRoles={[VENDOR]}
          />
        ),
        children: [
          {
            path: "",
            element: <ProductManager />,
            children: [
              {
                index: true,
                element: <ProductsOverview />,
              },
              {
                path: "details/:id",
                children: [
                  { index: true, element: <ProductDetails /> },
                  { path: "eventlog/:vid", element: <ProductEventLog /> }, // not sure why we need id AND vid here?
                  {
                    path: "assurancemaintenance/:maintenance_id",
                    element: <AssuranceMaintenanceDetails />,
                  },
                  { path: "nist/:nist_id", element: <NistDetails /> },
                  {
                    path: "updates",
                    element: <AuthenticatedRoute allowedRoles={[NIAP]} />,

                    children: [
                      {
                        path: "",
                        element: <ProductUpdates />,
                        children: [
                          {
                            path: "add",
                            element: <ProductUpdateModal />,
                          },
                          {
                            path: ":updateId/edit",
                            element: <ProductUpdateModal editMode />,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "proficiency-feedback",
                    element: (
                      <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR]} />
                    ),
                    children: [
                      { path: "", element: <ProficiencyFeedbackModal /> },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export default productRoutes;
